var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "counterparty" }, [
    _c(
      "div",
      { staticClass: "panel-content" },
      [
        _c("b-table", {
          attrs: { striped: "", items: _vm.org_items, fields: _vm.fields },
          scopedSlots: _vm._u([
            {
              key: "cell(text_block)",
              fn: function (row) {
                return [
                  row.item.has_stop
                    ? _c("div", [
                        _vm._v(
                          "Контрагент знаходиться в чорному списку, за роз'ясненнями звертатися до керівництва ФЕБ"
                        ),
                      ])
                    : _vm._e(),
                ]
              },
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }